import Vue from "vue";
import Vuex from "vuex";
import VueAxios from "vue-axios";
import axios from "axios";

Vue.use(Vuex);
Vue.use(VueAxios, axios);

const namespaced = true;

const state = {
  halfBackground: false,
  menuBackground: false,
  halfMenuBackground: false,
  wideView: false
};

const getters = {
  halfBackground: state => state.halfBackground,
  menuBackground: state => state.menuBackground,
  halfMenuBackground: state => state.halfMenuBackground
};

const mutations = {
  setBackgroundState(state, bgState) {
    state.halfBackground = bgState;
  },
  setMenuBackgroundState(state, bgState) {
    state.menuBackground = bgState;
  },
  setHalfMenuBackgroundState(state, bgState) {
    state.halfMenuBackground = bgState;
  },
  setPageView(state, wideView) {
    state.wideView = wideView;
  }
};

const actions = {
  setHalfBackground({ commit }) {
    commit("setBackgroundState", true);
    commit("setMenuBackgroundState", false);
    commit("setHalfMenuBackgroundState", false);
  },
  setWhiteBackground({ commit }) {
    commit("setBackgroundState", false);
    commit("setMenuBackgroundState", false);
    commit("setHalfMenuBackgroundState", false);
  },
  setMenuBackground({ commit }) {
    commit("setMenuBackgroundState", true);
    commit("setBackgroundState", false);
    commit("setHalfMenuBackgroundState", false);
  },
  setHalfMenuBackground({ commit }) {
    commit("setHalfMenuBackgroundState", true);
    commit("setBackgroundState", false);
    commit("setMenuBackgroundState", false);
  },
  setFullPageView({ commit }) {
    commit("setPageView", true);
  },
  setCenterPageView({ commit }) {
    commit("setPageView", false);
  }
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
